import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=0b6f3c66&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style1 from "./SocialIcons.vue?vue&type=style&index=1&id=0b6f3c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f3c66",
  null
  
)

export default component.exports